import { SiAnthropic, SiGooglegemini } from "@icons-pack/react-simple-icons";
import { Server } from "lucide-react";
import { cn } from "@nexus/ui";
import type { ModelBrand } from "../lib/model-display";

interface ProviderIconProps {
  brand: ModelBrand;
  className?: string;
}

/**
 * Brand glyphs for LLM providers (Simple Icons) — never emoji.
 *
 * Hidden from assistive tech: every caller renders the model name beside it, and
 * the vendor is the first word of that name.
 */
export function ProviderIcon({ brand, className }: ProviderIconProps) {
  const iconClass = cn("size-3.5 shrink-0", className);

  if (brand === "anthropic") {
    return <SiAnthropic className={cn(iconClass, "text-foreground")} aria-hidden title="" />;
  }
  if (brand === "google") {
    return <SiGooglegemini className={cn(iconClass, "text-violet")} aria-hidden title="" />;
  }
  return <Server className={cn(iconClass, "text-muted-foreground")} aria-hidden />;
}
